export default __webpack_public_path__ + "static/media/Emotion_Disgust.0295746c.svg";